import api from "./apiClient";

export default async function logIn(email, password) {
	const response = await api.post("/login", {
		email: email,
		password: password,
	}, {
		skipAuth: true  // Login endpoint doesn't require authentication
	});
	return response;
}